// VH-229 refinement: validator problem codes of a weekly plan ("day_kcal_off_target:2400_vs_2310_tolerance_5%")
// turned into translation keys and values. Unknown codes are shown as they are.

const PATTERNS = [
  [/^day_(kcal|protein_g|carbs_g)_off_target:(\d+)_vs_(\d+)_tolerance_(\d+)%$/, (m) => ({ key: `offTarget.${m[1]}`, values: { actual: m[2], target: m[3], tolerance: m[4] } })],
  [/^day_fiber_below_target:(\d+)_vs_(\d+)$/, (m) => ({ key: 'fiberBelow', values: { actual: m[1], target: m[2] } })],
  [/^freezer_step_required:cooked_meat_keeps_(\d+)_days_for_(\d+)_container_days$/, (m) => ({ key: 'freezer', values: { days: m[1], containers: m[2] } })],
  [/^eggs_above_limit:(.+)$/, (m) => ({ key: 'eggs', values: { limit: m[1] } })],
  [/^sweet_baked_above_limit:(.+)$/, (m) => ({ key: 'sweetBaked', values: { limit: m[1] } })],
  // VH-257: out of credit is not "not available" — waiting never fixes it.
  [/^generator_error:ai_out_of_credit$/, () => ({ key: 'outOfCredit', values: {} })],
  [/^generator_error:/, () => ({ key: 'generator', values: {} })],
  [/^empty_menu$/, () => ({ key: 'emptyMenu', values: {} })],
]

export function describeProblem(code) {
  for (const [pattern, build] of PATTERNS) {
    const match = String(code).match(pattern)
    if (match) return build(match)
  }
  return null
}
